import * as React from "react";
import { useCallback, useMemo } from "react";
import RowCheckbox from "components/common/EntityDataTable/RowCheckbox";
import { compareWidgetRefs, widgetId } from "report/report-creation/content/types";
const BulkSelectCheckBox = ({ dashboards, disabledWidgets, onChange, selected }) => {
  const allWidgets = useMemo(
    () => dashboards.flatMap(
      (d) => d.widgets.filter((widget) => widget.eligible).map((widget) => widgetId(widget, d)).filter(
        (widgetRef) => disabledWidgets.find((disabled2) => compareWidgetRefs(disabled2, widgetRef)) === void 0
      )
    ),
    [dashboards, disabledWidgets]
  );
  const disabled = useMemo(() => allWidgets.length === 0, [allWidgets.length]);
  const allSelected = useMemo(
    () => !disabled && allWidgets.find((widget) => !selected.includes(widget)) === void 0,
    [allWidgets, disabled, selected]
  );
  const toggleAll = useCallback(() => {
    if (allSelected) {
      onChange([]);
    } else {
      onChange(allWidgets);
    }
  }, [allSelected, allWidgets, onChange]);
  return /* @__PURE__ */ React.createElement(RowCheckbox, { onChange: toggleAll, checked: allSelected, title: allSelected ? "Unselect all" : "Select all" });
};
export default BulkSelectCheckBox;
